import "../../assets/styles/mobile/walletpagemob.scss";
import MobileLayoutRenderer from "./layout/MobileLayoutRenderer";
import HeaderMobile from "../../components/mobile/HeaderMobile";
import RewardCardMob from "../../components/mobile/RewardCardMob";
import { useEffect, useState } from "react";
import { apiJson } from "../../Api";
import { useTranslation } from "react-i18next";

const RewardsPageMob = () => {
  const [rewardPoints, setRewardPoints] = useState({});
  const { t } = useTranslation();

  useEffect(() => {
    apiJson.rewards.getRewardPoints().then((response) => {
      if (response.success) {
        setRewardPoints(response.data);
      }
    });
  }, []);

  return (
    <MobileLayoutRenderer
      NavbarTop={false}
      BackBtn={true}
      CancelBtn={false}
      NavbarBottom={true}
      SearchIcon={true}
    >
      <div className="home-mob">
        <HeaderMobile />
      </div>
      <div className="wallet-page-mob-main-container">
        <div
          className="mt-3"
          style={{
            display: "grid",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          <div style={{ color: "green", fontWeight: 500 }}>
            {t("rewards.available-points")}
          </div>

          <span>{rewardPoints.total_points}</span>
        </div>
        <div className="wallet-card-lsit-inpage px-3">
          <RewardCardMob />
        </div>
      </div>
    </MobileLayoutRenderer>
  );
};

export default RewardsPageMob;
